import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useGoogleAnalytics = () => {
  const location = useLocation();
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID;

  useEffect(() => {
    // Only initialize if GA ID is present and consent is given
    if (!GA_MEASUREMENT_ID || !window.gtag) {
      return;
    }

    // Check cookie consent
    const consent = localStorage.getItem('vra_cookie_consent');
    
    if (consent === 'accepted') {
      // Track page view on route change
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, GA_MEASUREMENT_ID]);
};

// Helper function to track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID;
  const consent = localStorage.getItem('vra_cookie_consent');
  
  if (GA_MEASUREMENT_ID && window.gtag && consent === 'accepted') {
    window.gtag('event', eventName, eventParams);
  }
};
